import styled from "styled-components";

export const Container = styled.div`
    --button-width: 10rem;
    margin-left: 1rem
`